import { useTranslation } from "react-i18next";
import { MessageSquare, Search, X } from "@digital-twins/design-system/icons";
import { Button } from "@/components/ui/button";
import type { KnowledgeLibrarySearchProps } from "@/types/components/knowledge-library-search";

export function LibrarySearch({
  value,
  onChange,
  onAsk,
  compact = false,
  placeholder,
  clearLabel,
}: KnowledgeLibrarySearchProps) {
  const { t } = useTranslation("app");
  return (
    <div className="min-w-0 flex-1" data-testid="knowledge-search-row">
      <div
        className={`relative flex min-w-0 items-center gap-2.5 rounded-2xl border border-primary/25 bg-background p-1.5 pl-4 shadow-sm transition-colors hover:border-primary/40 focus-within:border-primary/60 focus-within:ring-2 focus-within:ring-primary/15 ${compact ? "h-12" : "h-14"}`}
        data-testid="knowledge-search"
      >
        <Search className="h-4 w-4 shrink-0 text-primary" />
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key !== "Enter") return;
            if (e.nativeEvent.isComposing) return;
            e.preventDefault();
          }}
          aria-label={placeholder ?? t("library.searchPlaceholder")}
          placeholder={placeholder ?? t("library.searchPlaceholder")}
          className="h-full w-0 min-w-0 flex-1 bg-transparent text-[15px] text-foreground outline-none placeholder:text-muted-foreground"
          data-testid="knowledge-search-input"
        />
        {value ? (
          <button
            type="button"
            aria-label={clearLabel ?? t("library.searchClear")}
            className="flex h-6 w-6 items-center justify-center rounded-full text-muted-foreground hover:bg-accent hover:text-foreground"
            data-testid="knowledge-search-clear"
            onClick={() => onChange("")}
          >
            <X className="h-3.5 w-3.5" />
          </button>
        ) : null}
        {onAsk ? (
          <Button
            type="button"
            className="h-9 shrink-0 gap-2 rounded-xl px-3 font-medium"
            onClick={() => onAsk(value.trim())}
            data-testid="knowledge-search-ask"
          >
            <MessageSquare className="h-4 w-4" aria-hidden="true" />
            {t("nav.ask")}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
